export function normalizePortLocation(value) {
  return String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[\s_]+/g, "-");
}

export function isNorthStockpileLocation(value) {
  const normalized = normalizePortLocation(value);
  return normalized === "NORTH-STOCKPILE" || normalized === "NORT-STOCKPILE";
}

export function isCpLocation(value) {
  return /^CP-?[A-Z0-9]+$/.test(normalizePortLocation(value));
}

export function getPortDetailPath(location) {
  return isNorthStockpileLocation(location)
    ? "/dashboard-port/detail/north-stockpile"
    : "/dashboard-port/detail/cp";
}

export function getPortScopeFromPath(path) {
  return String(path || "").includes("north-stockpile")
    ? "north-stockpile"
    : "cp";
}
